export default __webpack_public_path__ + "static/media/secure-warning-bg.78893f72.png";